import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './StudioCreate.css';
import { API_CONFIG } from '../../config/api';

export const StudioCreate = () => {
  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }


  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    artist_id: '',
    tour_name: '',
    tour_profile: null,
    tour_hashtag: '',
    tour_description: '',
    tour_phone: '',
    tour_website: '',
    tour_location: '',
    tour_location_do: '',
    tour_location_si: '',
    tour_location_lat: '',
    tour_location_lng: '',
    tour_type: '아틀리에',
    tour_price: '',
    tour_open_days: [],
    tour_open_time: '10:00',
    tour_close_time: '18:00',
    tour_break_time: '12:00-13:00',
    tour_break_time_start: '12:00',
    tour_break_time_end: '13:00',
    tour_max_per_time: 20
  });

  useEffect(() => {
    const artistId = getCookie('yournest_a_id');
    if (!artistId) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    setFormData(prev => ({ ...prev, artist_id: artistId }));
  }, []);

  useEffect(() => {
    const loadKakaoScript = async () => {
      // 우편번호 스크립트 로드
      const postScript = document.createElement("script");
      postScript.src = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
      document.head.appendChild(postScript);

      // Kakao 맵 스크립트 로드
      return new Promise((resolve) => {
        const mapScript = document.createElement("script");
        mapScript.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=cdabbe0b4373d904f58d672d596b6630&libraries=services&autoload=false";
        mapScript.async = true;
        
        mapScript.onload = () => {
          window.kakao.maps.load(() => {
            console.log("Kakao maps loaded with services");
            resolve();
          });
        };
        document.head.appendChild(mapScript);
      });
    };

    loadKakaoScript();
  }, []);

  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: function(data) {
        const addr = data.address;
        const sido = data.sido;
        const sigungu = data.sigungu;
        
        setFormData(prev => ({
          ...prev,
          tour_location: addr,
          tour_location_do: sido,
          tour_location_si: sigungu
        }));
        
        const geocoder = new window.kakao.maps.services.Geocoder();
        geocoder.addressSearch(addr, function(result, status) {
          if (status === window.kakao.maps.services.Status.OK) {
            setFormData(prev => ({
              ...prev,
              tour_location_lat: result[0].y,
              tour_location_lng: result[0].x
            }));
          } else {
            alert("주소를 좌표로 변환하는데 실패했습니다. 다시 시도해주세요.");
          }
        });
      }
    }).open();
  };

  const DAY_TO_NUMBER = {
    '일': 0,
    '월': 1,
    '화': 2,
    '수': 3,
    '목': 4,
    '금': 5,
    '토': 6
  };

  const handleDayToggle = (day) => {
    const dayNumber = DAY_TO_NUMBER[day];
    setFormData(prev => ({
      ...prev,
      tour_open_days: prev.tour_open_days.includes(dayNumber)
        ? prev.tour_open_days.filter(d => d !== dayNumber)
        : [...prev.tour_open_days, dayNumber].sort((a, b) => a - b)
    }));
  };

  const handleCreate = async () => {
    if (!formData.tour_location_lat || !formData.tour_location_lng) {
      alert('유효한 주소를 입력해주세요.');
      return;
    }

    try {
      let profileFilename = null;
      
      if (formData.tour_profile) {
        const imageFormData = new FormData();
        imageFormData.append('tour_profile', formData.tour_profile);
        
        const uploadResponse = await fetch(`${API_CONFIG.MAIN}/upload_tour_profile`, {
          method: 'POST',
          body: imageFormData
        });

        if (!uploadResponse.ok) throw new Error('이미지 업로드 실패');
        const uploadResult = await uploadResponse.json();
        profileFilename = uploadResult.filename;
      }

      const response = await fetch(`${API_CONFIG.MAIN}/create_tour`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          tour_open_days: formData.tour_open_days.join(','),
          tour_profile: profileFilename
        })
      });

      if (!response.ok) throw new Error('스튜디오 등록 실패');
      
      alert('스튜디오가 등록되었습니다.');
      navigate('/artist-studio');
    } catch (error) {
      console.error('스튜디오 등록 실패:', error);
      alert('스튜디오 등록에 실패했습니다.');
    }
  };

  return (
    <div className="studio-create">
      {/* Block: create-form */}
      <div className="create-form">
        <div className="create-form__title">새 아틀리에 등록</div>
        <div className="create-form__input-group">
          <label>아틀리에 이름 *</label>
          <input
            type="text"
            value={formData.tour_name}
            onChange={e => setFormData({...formData, tour_name: e.target.value})}
            required
          />
        </div>
        <div className="create-form__input-group">
          <label>해시태그</label>
          <input
            type="text"
            value={formData.tour_hashtag}
            onChange={e => setFormData({...formData, tour_hashtag: e.target.value})}
            placeholder="#공방 #도예 #클래스"
          />
        </div>
        <div className="create-form__input-group">
          <label>아틀리에 설명 *</label>
          <textarea
            value={formData.tour_description}
            onChange={e => setFormData({...formData, tour_description: e.target.value})}
            required
          />
        </div>
        <div className="create-form__input-group">
          <label>주소 *</label>
          <div className="create-form__address-input">
            <input
              type="text"
              value={formData.tour_location}
              readOnly
              required
            />
            <button type="button" onClick={handleAddressSearch}>
              주소 검색
            </button>
          </div>
        </div>
        <div className="create-form__input-group">
          <label>유형 *</label>
          <select
            value={formData.tour_type}
            onChange={e => setFormData({...formData, tour_type: e.target.value})}
            required
          >
            <option value="아틀리에">아틀리에</option>
            {/* <option value="스튜디오">스튜디오</option>
            <option value="레지던시">레지던시</option> */}
          </select>
        </div>
        <div className="create-form__input-group">
          <label>가격 *</label>
          <input
            type="number"
            value={formData.tour_price}
            onChange={e => setFormData({...formData, tour_price: e.target.value})}
            required
          />
        </div>
        <div className="create-form__input-group">
          <label>운영 요일</label>
          <div className="create-form__days-selector">
            {['일', '월', '화', '수', '목', '금', '토'].map(day => (
              <button
                key={day}
                type="button"
                className={formData.tour_open_days.includes(DAY_TO_NUMBER[day]) ? 'active' : ''}
                onClick={() => handleDayToggle(day)}
              >
                {day}
              </button>
            ))}
          </div>
        </div>
        <div className="create-form__input-group">
          <label>운영 시간 *</label>
          <div className="create-form__time-inputs">
            <input
              type="time"
              value={formData.tour_open_time}
              onChange={e => setFormData({...formData, tour_open_time: e.target.value})}
              required
            />
            <span>~</span>
            <input
              type="time"
              value={formData.tour_close_time}
              onChange={e => setFormData({...formData, tour_close_time: e.target.value})}
              required
            />
          </div>
        </div>
        <div className="create-form__input-group">
          <label>브레이크타임</label>
          <div className="create-form__time-inputs">
            <input
              type="time"
              value={formData.tour_break_time_start}
              onChange={e => setFormData({
                ...formData, 
                tour_break_time_start: e.target.value,
                tour_break_time: `${e.target.value}-${formData.tour_break_time_end}`
              })}
              placeholder="12:00"
            />
            <span>~</span>
            <input
              type="time"
              value={formData.tour_break_time_end}
              onChange={e => setFormData({
                ...formData, 
                tour_break_time_end: e.target.value,
                tour_break_time: `${formData.tour_break_time_start}-${e.target.value}`
              })}
              placeholder="13:00"
            />
          </div>
        </div>
        <div className="create-form__input-group">
          <label>최대 인원 *</label>
          <input
            type="number"
            value={formData.tour_max_per_time}
            onChange={e => setFormData({...formData, tour_max_per_time: e.target.value})}
            required
          />
        </div>
        <div className="create-form__input-group">
          <label>전화번호 *</label>
          <input
            type="tel"
            value={formData.tour_phone}
            onChange={e => setFormData({...formData, tour_phone: e.target.value})}
            required
          />
        </div>
        <div className="create-form__input-group">
          <label>웹사이트</label>
          <input
            type="url"
            value={formData.tour_website}
            onChange={e => setFormData({...formData, tour_website: e.target.value})}
          />
        </div>
        <div className="create-form__input-group">
          <label>대표 이미지 *</label>
          <div>
            <label className="create-form__file-input-label">
              파일 선택
              <input
                type="file"
                onChange={e => {
                  setFormData({...formData, tour_profile: e.target.files[0]});
                }}
                accept="image/*"
                required
              />
            </label>
            {formData.tour_profile && (
              <span className="create-form__file-name">
                {formData.tour_profile.name}
              </span>
            )}
          </div>
        </div>
        <div className="create-form__button-group">
          <div className="create-form__submit-button" onClick={handleCreate}>등록하기</div>
          <div className="create-form__cancel-button" onClick={() => navigate('/artist-studio')}>취소</div>
        </div>
      </div>
    </div>
  );
};